import { Component, OnInit } from '@angular/core';
import { AdminService, AppAuthServiceService, CatalogService, UserPreferencesService } from '@core';
import { language, SystemStatus } from '@shared';
import { forkJoin, Observable, of } from 'rxjs';
import zoomFadeIn from 'src/app/shared/animations/zoom-fadeIn.animation';
import fadeIn from 'src/app/shared/animations/fadeIn.animation';
import { CasesType } from '@shared';
@Component({
    selector: 'ups-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    animations: [zoomFadeIn, fadeIn],
    standalone: false
})
export class HomeComponent implements OnInit {
  public casesType = CasesType;
  public isAdmin: boolean = false;
  public userName: string | undefined = '';
  public systemStatus$: Observable<Partial<SystemStatus>> = of();
  public render = true;
  public systemStatus: Partial<SystemStatus> = {};
  public activeAccordion: string | string[] = '';

  constructor(
    public appAuthService: AppAuthServiceService,
    private userPreferences: UserPreferencesService,
    private catalogService: CatalogService,
    public adminService: AdminService
  ) {}

  ngOnInit(): void {
    this.appAuthService.isAdmin.subscribe((value) => (this.isAdmin = value));
    this.userName = this.appAuthService.account.name;
    this.checkSystemStatus();
    this.cacheCatalogsRequests();
  }

  private cacheCatalogsRequests(): void {
    const accountId = this.appAuthService.account.homeAccountId || '';
    let pref: any = {};
    this.userPreferences.getUserPreferences(accountId).subscribe((preferences) => {
      if (!preferences.error) {
        pref = preferences;
      }
      pref.language ??= language.default;
      this.catalogService.setLanguage(pref.language);
      const requestsToCache = [
        this.catalogService.formSchema(pref.language),
        this.catalogService.inquiryCountry(),
        this.catalogService.contactType(),
        this.catalogService.country(),
        this.catalogService.preferredCommunicationChannel(),
        this.catalogService.language(),
        this.catalogService.shipmentIdentifier(),
        this.catalogService.priority(),
        this.catalogService.receivedFrom(),
      ];

      forkJoin(requestsToCache).subscribe();
    });
  }

  private checkSystemStatus(): void {
    this.systemStatus$ = this.adminService.currentSystemStatus;
  }
}
